import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Status/Success/True/False">
<circle id="Status" cx="4" cy="4" r="4" />
</g>
</svg>
`;

export const Dot = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
